import * as angular from 'angular';

import { ComponentDefinition, IFrequency as Frequency } from '../../../models';

class FrequencySelectorController implements angular.IComponentController {
    readonly frequencies: Frequency[];
    readonly onClick: ({ frequency: Frequency }) => void;
    readonly selectedFrequency;// Type to be determined

    static $inject = [];

    click($event: angular.IAngularEvent, freq: Frequency) {
        if (this.onClick) {
            this.onClick({ frequency: freq });
        }
    }
}

export const wtFrequencySelector: ComponentDefinition = {
    componentId: 'wtFrequencySelector',
    controller: FrequencySelectorController,
    template: require('./frequencySelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        frequencies: '<',
        onClick: '&?',
        selectedFrequency: '<?'
    }
};